//      
import { useMemo } from 'use-memo-one';
                                             

let count = 0;

export function reset() {
  count = 0;
}

export default function useInstanceCount()            {
  return useMemo(() => `${count++}`, []);
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/drag-drop-context/use-unique-context-id.js